import React from 'react';
import { BarChart3 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export const VisitorStatsCard = ({ visitorStats }) => {
    if (!visitorStats) return null;

    return (
        <Card className="mb-8 border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl" data-testid="visitor-stats-card">
            <CardHeader className="flex flex-row items-center justify-between pb-3">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center">
                        <BarChart3 className="h-5 w-5 text-blue-600" />
                    </div>
                    <div>
                        <CardTitle className="font-heading text-jungle text-base">Statistiques visiteurs</CardTitle>
                        <p className="text-xs text-muted-foreground">Trafic du site en temps reel</p>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    <div className="p-4 rounded-xl bg-blue-50 border border-blue-100 text-center">
                        <p className="text-2xl font-bold text-blue-700" data-testid="visitors-today">{visitorStats.today}</p>
                        <p className="text-xs text-blue-600 mt-1">Visiteurs aujourd'hui</p>
                    </div>
                    <div className="p-4 rounded-xl bg-emerald-50 border border-emerald-100 text-center">
                        <p className="text-2xl font-bold text-emerald-700" data-testid="visitors-unique">{visitorStats.total_unique}</p>
                        <p className="text-xs text-emerald-600 mt-1">Visiteurs uniques (total)</p>
                    </div>
                    <div className="p-4 rounded-xl bg-purple-50 border border-purple-100 text-center">
                        <p className="text-2xl font-bold text-purple-700" data-testid="visitors-total">{visitorStats.total_visits}</p>
                        <p className="text-xs text-purple-600 mt-1">Visites totales</p>
                    </div>
                </div>
                {visitorStats.daily && visitorStats.daily.length > 0 && (
                    <ResponsiveContainer width="100%" height={200}>
                        <BarChart data={visitorStats.daily}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="date" tickFormatter={(d) => d.slice(5)} fontSize={10} />
                            <YAxis allowDecimals={false} fontSize={10} />
                            <Tooltip
                                labelFormatter={(d) => `Date: ${d}`}
                                formatter={(v) => [`${v} visiteur(s)`, 'Visiteurs']}
                            />
                            <Bar dataKey="visitors" fill="hsl(199, 70%, 50%)" radius={[4, 4, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </CardContent>
        </Card>
    );
};
